module.exports = __webpack_public_path__ + "img/liucheng3.df4ba671.jpg";